import { render, staticRenderFns } from "./KeywordChips.vue?vue&type=template&id=51be5312"
import script from "./KeywordChips.vue?vue&type=script&lang=js"
export * from "./KeywordChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports